// 退出免审
export const exitExemptExamine = (params) => {
  return window._this.$http.post(`/erp/Supply/exitExemptExamine`, params);
};
// 设置商家商家性质
export const setSupplyCharacter = (params) => {
  return window._this.$http.post(`/erp/Supply/setSupplyCharacter`, params);
};



// WEBPACK FOOTER //
// ./src/api/update-supply.js